import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ApiService } from './api.service';

export type RestaurantPage = 'menu' | 'reservations';

// Asks the master before showing a restaurant's digital menu or reservations
// site (POST /companies/:name/page_view). It counts the free plan's monthly
// visits and refuses when they ran out or the restaurant's payment is late.
// Emits null to show the page, or the message for the customer.
// Any other failure shows the page: the customer is never stuck by an error.
@Injectable({ providedIn: 'root' })
export class PageAccessService {
  constructor(private http: HttpClient, private api: ApiService) {}

  check(companyName: string, page: RestaurantPage): Observable<string | null> {
    const url = `${this.api.getTargetUrl()}/companies/${encodeURIComponent(companyName)}/page_view`;
    return this.http.post(url, { page }).pipe(
      map(() => null),
      catchError(error => {
        if (error?.status === 403 && error?.error?.code === 'feature_unavailable') {
          const message = error.error.errors?.[0];
          return of(message || 'Esta página não está disponível no momento.');
        }
        return of(null);
      })
    );
  }
}
